/**
 * Retired public URLs → the kept URL for the same search intent.
 * The prerenderer writes a static redirect document at each retired path (canonical,
 * 0-second meta refresh, plain link, script redirect); the app redirects in-browser too.
 * Retired paths must not appear in content data, the sitemap or llms.txt.
 */
export const SEO_REDIRECTS: Record<string, string> = {
  "/compliance/ahpra-practitioner-testimonials-prohibited": "/insights/testimonials-endorsements-practitioner-advertising-australia-2026",
  "/insights/tga-compliance-principles-2026-2027-health-practitioners-australia": "/insights/tga-compliance-principles-2026-2027-supplement-brands-australia",
  "/compliance/nutritionist-dietitian-advertising-compliance-australia": "/compliance/nutritionist-advertising-rules-australia",
  "/compliance/phi-rebate-natural-therapies-australia-2025": "/insights/phi-rebate-natural-therapies-advertising-compliance-australia-2026",
};
